import React from 'react';
import classnames from 'classnames';

import { ReactComponent as Spinner } from 'images/spinner.svg';

const Button = ({ className, children, disabled, loading, keepColor, ...props }) => (
  <button
    className={classnames('py-2 px-6 uppercase font-bold rounded-lg relative', className, {
      'bg-turquoise text-brandblue cursor-pointer': !disabled || keepColor,
      'bg-gray-800 text-gray-200 cursor-default': disabled && !keepColor,
    })}
    disabled={disabled}
    {...props}
  >
    <span
      className={classnames({
        'opacity-0': loading,
      })}
    >
      {children}
    </span>

    {loading && (
      <div className="flex items-center justify-center absolute left-0 top-0 w-full h-full">
        <Spinner className="w-10 inline-block align-middle fill-current" alt="Loader" />
      </div>
    )}
  </button>
);

export default Button;
